"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _css = _interopRequireDefault(require("dom-helpers/css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Transition = _interopRequireWildcard(require("react-transition-group/Transition"));

var _excluded = ["children"];

var _collapseStyles;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var collapseStyles = (_collapseStyles = {}, (0, _defineProperty2.default)(_collapseStyles, _Transition.EXITED, 'collapse'), (0, _defineProperty2.default)(_collapseStyles, _Transition.EXITING, 'collapsing'), (0, _defineProperty2.default)(_collapseStyles, _Transition.ENTERING, 'collapsing'), (0, _defineProperty2.default)(_collapseStyles, _Transition.ENTERED, 'collapse in'), _collapseStyles);
var MARGINS = {
  height: ['marginTop', 'marginBottom']
};
var INITIAL_HEIGHT = '0';

var Collapse = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Collapse, _React$Component);

  var _super = _createSuper(Collapse);

  function Collapse(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Collapse);
    _this = _super.call(this, props);
    _this.state = {};
    _this.handleEnter = _this.handleEnter.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleEntering = _this.handleEntering.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleEntered = _this.handleEntered.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleExit = _this.handleExit.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleExiting = _this.handleExiting.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleExited = _this.handleExited.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Collapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.in) {
        // When the component is collapsed on mount, set initial height to 0
        this.setState(function () {
          return {
            transitionState: _Transition.EXITED,
            height: INITIAL_HEIGHT
          };
        });
      } else {
        // When the component is expanded on mount, set initial height to 'auto'
        this.setState(function () {
          return {
            transitionState: _Transition.ENTERED,
            height: 'auto'
          };
        });
      }
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // As the height is set to "auto" in the final opening step, we need to
      // set the height before we start the closing animation as "height: auto" cannot be animated
      if (this.props.in && !nextProps.in) {
        this.setState({
          height: this.getFullHeight(_reactDom.default.findDOMNode(this))
        });
      }
    }
  }, {
    key: "getFullHeight",
    value: function getFullHeight(element) {
      var value = element.offsetHeight;
      var margins = MARGINS['height'];

      if (!value) {
        return INITIAL_HEIGHT;
      }

      var fullHeight = value + parseInt((0, _css.default)(element, margins[0]), 10) + parseInt((0, _css.default)(element, margins[1]), 10);
      return fullHeight;
    }
    /* -- Expanding -- */

  }, {
    key: "handleEnter",
    value: function handleEnter() {
      this.setState(function () {
        return {
          transitionState: _Transition.ENTERED,
          height: INITIAL_HEIGHT
        };
      }, this.props.onEnter());
    }
  }, {
    key: "handleEntering",
    value: function handleEntering(element) {
      this.setState(function () {
        return {
          transitionState: _Transition.ENTERING,
          height: element.scrollHeight
        };
      }, this.props.onEntering());
    }
  }, {
    key: "handleEntered",
    value: function handleEntered() {
      this.setState(function () {
        return {
          transitionState: _Transition.ENTERED,
          height: 'auto'
        };
      }, this.props.onEntered());
    }
    /* -- Collapsing -- */

  }, {
    key: "handleExit",
    value: function handleExit(element) {
      var _this2 = this;

      this.setState(function () {
        return {
          transitionState: _Transition.EXITING,
          height: _this2.getFullHeight(element)
        };
      }, this.props.onExit());
    }
  }, {
    key: "handleExiting",
    value: function handleExiting() {
      this.setState(function () {
        return {
          transitionState: _Transition.EXITING,
          height: INITIAL_HEIGHT
        };
      }, this.props.onExiting());
    }
  }, {
    key: "handleExited",
    value: function handleExited() {
      this.setState(function () {
        return {
          transitionState: _Transition.EXITED,
          height: INITIAL_HEIGHT
        };
      }, this.props.onExited());
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement(_Transition.default, (0, _extends2.default)({
        ref: function ref(node) {
          return _this3.refTransition = node;
        }
      }, props, {
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered,
        onExit: this.handleExit,
        onExiting: this.handleExiting,
        onExited: this.handleExited
      }), /*#__PURE__*/_react.default.cloneElement(children, {
        style: {
          height: this.state.height
        },
        className: (0, _classnames.default)(children.props.className, collapseStyles[this.state.transitionState])
      }));
    }
  }]);
  return Collapse;
}(_react.default.Component);

exports.default = Collapse;
Collapse.defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  onEnter: function onEnter() {},
  onEntering: function onEntering() {},
  onEntered: function onEntered() {},
  onExit: function onExit() {},
  onExiting: function onExiting() {},
  onExited: function onExited() {}
};
Collapse.propTypes = {
  // Show the component; triggers the expand or collapse animation
  in: _propTypes.default.bool.isRequired,
  // Wait until the first "enter" transition to mount the component (add it to the DOM)
  mountOnEnter: _propTypes.default.bool,
  // Unmount the component (remove it from the DOM) when it is collapsed
  unmountOnExit: _propTypes.default.bool,
  // Run the expand animation when the component mounts, if it is initially shown
  appear: _propTypes.default.bool,
  // Duration of the collapse animation in milliseconds, to ensure that finishing callbacks
  // are fired even if the original browser transition end events are canceled
  timeout: _propTypes.default.number,
  // Callback fired before the component expands
  onEnter: _propTypes.default.func,
  // Callback fired after the component starts to expand
  onEntering: _propTypes.default.func,
  // Callback fired after the component has expanded
  onEntered: _propTypes.default.func,
  // Callback fired before the component collapses
  onExit: _propTypes.default.func,
  // Callback fired after the component starts to collapse
  onExiting: _propTypes.default.func,
  // Callback fired after the component has collapsed
  onExited: _propTypes.default.func
};